import { ApiError } from "@vana/core";

export class FileProblemReportError extends ApiError {}
export class UploadEvidenceError extends ApiError {}
